import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @record.lastMeasureDate}}\n  {{format-date-relative @record.lastMeasureDate (hash isShort=true)}}\n{{else}}\n  -\n{{/if}}")